export default [
    {
        path: '/field-staff/schedule',
        name: 'FieldStaffSchedule',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Schedule',
        },
        components: {
            default: () => import('@views/field-staff/ScheduleIndex.vue'),
        },
    },
    {
        path: '/field-staff/notifications',
        name: 'FieldStaffNotifications',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Notifications',
        },
        components: {
            default: () => import('@views/field-staff/NotificationsIndex.vue'),
        },
    },
    {
        path: '/field-staff/runsheets',
        name: 'FieldStaffRunsheets',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Runsheets',
        },
        components: {
            default: () => import('@views/field-staff/RunsheetsIndex.vue'),
        },
    },
    {
        path: '/field-staff/runsheets/:scheduleId',
        name: 'FieldStaffRunsheetShow',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Runsheet',
        },
        components: {
            default: () => import('@views/field-staff/RunsheetShow.vue'),
        },
    },
];
